module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "theme",
      rawName: "v-theme",
      value: ('wide'),
      expression: "'wide'"
    }],
    attrs: {
      "id": "show-adressen"
    }
  }, [_c('h1', [_vm._v(" Alle Adressen ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Adressen durchsuchen ..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.filteredAdressen), function(adresse) {
    return _c('div', {
      key: adresse.id,
      staticClass: "single-adressen"
    }, [_c('p', [_vm._v(_vm._s(adresse.strasse) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(adresse.plz) + " " + _vm._s(adresse.ort))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-020cb357","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adressen/showAdressen.vue
// module id = 307
// module chunks = 0